// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._7I5mn{background-color:#fff;border-radius:2.5px;bottom:0;-webkit-box-shadow:0 0 18px rgba(0,0,0,.2);box-shadow:0 0 18px rgba(0,0,0,.2);height:30vh;left:50%;overflow-x:hidden;overflow-y:auto;padding:55px 25px 25px;position:fixed;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);width:90%;z-index:1039}@media (min-width:1024px){._7I5mn{bottom:1em;height:auto;left:auto;max-height:90%;max-width:375px;right:1em;-webkit-transform:translateX(0);-ms-transform:translateX(0);transform:translateX(0);width:26%}}._2P59R{cursor:pointer;padding:20px;position:absolute;right:0;top:0}.FL5qV{height:10px;width:10px}._3TBR8{color:#001f5b;font-size:13px;line-height:1.5;margin-bottom:0}", ""]);
// Exports
exports.locals = {
	"cookiesBox": "_7I5mn",
	"cookiesBox__closeWrapper": "_2P59R",
	"cookiesBox__closeIcon": "FL5qV",
	"cookiesBox__content": "_3TBR8"
};
module.exports = exports;
